/* eslint-disable jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */
import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';
import { IconCheveronDown } from '../Icons';
import InputCheckbox from '../InputCheckbox';

const NAME = 'multiCheckboxSelect';

const MultiCheckboxSelect = React.forwardRef((props, ref) => {
  const { name = NAME, values, labels, checked } = props;
  const [selectedItems, setSelectedItems] = useState(checked);
  const multiSelectRef = useRef();
  const multiSelectContentRef = useRef();
  const { t } = useTranslation();

  const handleChange = event => {
    setSelectedItems(selected => {
      if (event.target.checked) {
        selected.push(event.target.value);
      } else {
        selected.splice(selected.indexOf(event.target.value), 1);
      }

      return [...selected];
    });
  };

  const handleToggle = () => {
    multiSelectContentRef.current.classList.toggle('hidden');
  };

  const handleOutsideClick = event => {
    const { classList } = multiSelectContentRef.current;
    if (!multiSelectRef.current.contains(event.target) && !classList.contains('hidden')) {
      handleToggle();
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleOutsideClick);

    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, []);

  return (
    <div ref={multiSelectRef} className="relative">
      <div
        className="block w-full border border-slate-400 p-3 pr-8 rounded relative z-popup-menu"
        onClick={handleToggle}
      >
        <div className="leading-tight">
          {selectedItems.length
            ? t('MultiCheckboxSelect.count_title', {
                count: selectedItems.length,
              })
            : t('MultiCheckboxSelect.no_selection')}
        </div>
        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-slate-600">
          <IconCheveronDown />
        </div>
      </div>
      <div
        ref={multiSelectContentRef}
        className="flex-wrap h-auto w-full absolute -mt-2 bg-white rounded p-4 pt-6 shadow-md z-popup-backdrop hidden"
      >
        {labels.map((label, index) => (
          <div key={values[index]} className="flex mb-4 last:mb-0">
            <InputCheckbox
              id={`${name}_${index}`}
              ref={ref}
              onChange={handleChange}
              name={name}
              value={values[index]}
              className="mr-2"
              checked={selectedItems.includes(values[index])}
            />
            <label htmlFor={`${name}_${index}`} className="cursor-pointer">
              {label}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
});

MultiCheckboxSelect.propTypes = {
  name: PropTypes.string,
  values: PropTypes.arrayOf(PropTypes.string).isRequired,
  labels: PropTypes.arrayOf(PropTypes.string).isRequired,
  checked: PropTypes.arrayOf(PropTypes.string),
};

MultiCheckboxSelect.defaultProps = {
  checked: [],
};

export default MultiCheckboxSelect;
